<div class="flex flex-col gap-4 min-h-[35vh]">
  <div class="pb-4">{{getText().checkIn.body}}</div>
  <form (submit)="onSubmit()" [formGroup]="form" class="flex flex-col gap-4">
    @for (question of questions; track question) {
      <afcu-input [form]="form" [question]="question" (externalFunction)="selectEvent($event)"/>
    }
    
    @if (errorToShow) {
      <afcu-banner state="error" [content]="errorToShow.content"/>
    }

    <button 
      class="md:w-fit lg:w-fit py-3.5 bg-afcu-navy-800 px-6 font-semibold text-white rounded cursor-pointer flex items-center justify-center gap-2"
      [class.opacity-50]="appointmnent.isLoading()"
      [class.cursor-not-allowed]="appointmnent.isLoading()"
      [disabled]="appointmnent.isLoading()"
      type="submit">
        @if (appointmnent.isLoading()) {
          <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Checking...
        } @else {
          {{getText().checkIn.form.submit}}
        }
      </button>
  </form>
  
</div>
  